import React from 'react';
import styled, { keyframes } from 'styled-components';
import beeLogo from '../bee_logo.png';

const float = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  padding: 20px;
`;

const BeeImage = styled.img`
  width: 80px;
  height: auto;
  animation: ${float} 3s ease-in-out infinite;
  margin-bottom: -5px;
  
  @media (max-width: 480px) {
    width: 60px;
  }
`;

const LogoText = styled.h1`
  color: white;
  font-size: 48px;
  font-weight: bold;
  margin: 0;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.3);
  
  @media (max-width: 480px) {
    font-size: 36px;
  }
`;

const Logo = () => {
  return (
    <LogoContainer>
      <BeeImage src={beeLogo} alt="BusyBee Logo" />
      <LogoText>BusyBee</LogoText>
    </LogoContainer>
  );
};

export default Logo; 